import React from "react";

export default function PageHeader({ eyebrow, title, lead, image }) {
  return (
    <section
      className="relative pt-32 pb-20 lg:pt-44 lg:pb-28 overflow-hidden"
      data-testid="page-header"
    >
      {image && (
        <div className="absolute inset-0 -z-10">
          <img src={image} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-navy/95 via-navy/80 to-navy/50" />
        </div>
      )}
      <div className={`max-w-7xl mx-auto px-6 md:px-10 lg:px-12 ${image ? "text-white" : ""}`}>
        <div className={`label-eyebrow mb-6 ${image ? "text-gold" : ""}`}>{eyebrow}</div>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] font-light max-w-3xl">
          {title}
        </h1>
        {lead && (
          <p className={`mt-6 text-base lg:text-lg max-w-2xl ${image ? "text-slate-200" : "text-slate-600"}`}>
            {lead}
          </p>
        )}
        <div className="divider-gold mt-8" />
      </div>
    </section>
  );
}
